// Patient Verification subsection form field enum
export enum PatientVerificationFormField {
  LEGAL_NAME = 'patientBackground/legalName',
  PREFERRED_NAME = 'patientBackground/preferredName',
  ADDRESS = 'patientBackground/address',
  DATE_OF_BIRTH = 'patientBackground/dateOfBirth',
  GENDER = 'patientBackground/gender',
  MEDICAID_ID = 'patientBackground/medicaidId'
}
